<div
  class="back-drop"
  (click)="closeBottomSheet()"
  [ngStyle]="{
    background: !show ? 'transparent' : ' rgba(0, 0, 0, 0.4)'
  }"
></div>
<div class="container" [class.show]="show">
  <div class="header">
    <div class="top-handler" (swipedown)="swipe($event.type)">
      <div class="handler"></div>
    </div>
    <p class="change-package">عوض کردن پکیج</p>
    <div class="search-box">
      <div class="icon">
        <img src="assets/general/search.svg" />
      </div>
      <div class="input">
        <input
          type="text"
          [(ngModel)]="searchText"
          (ngModelChange)="search($event)"
          autocomplete="off"
          [placeholder]="'غذای مدنظر را جستجو کنید'"
        />
      </div>
    </div>
    <div class="switcher">
      <div class="switcher-key" (click)="switcher(0)">پکیج های پیشنهادی</div>

      <div class="switcher-key" (click)="switcher(1)">اخیرا</div>
      <div
        class="line"
        [ngStyle]="{ right: activeSwitch == 0 ? 0 : '50%' }"
      ></div>
    </div>
  </div>
  <div class="body">
    <div
      class="suggestions switcher-body"
      id="suggest-body"
      (scroll)="scrool()"
      [ngStyle]="{ right: activeSwitch == 0 ? 0 : '-100%' }"
    >
      <div
        class="food-option"
        [ngStyle]="{ 'margin-bottom': last ? '16px' : null }"
        *ngFor="let suggestion of suggestions; let last = last"
        (click)="openDetail(suggestion)"
      >
        <!-- <span class="label" (click)="openChart(suggestion)"
          >{{
            calorieCalculator.calculateSuggestions(
              suggestion.foods,
              suggestion.amount
            )
          }}
          کالری</span
        >
        <p class="title">پکیج پیشنهادی {{ title }}</p>

        <div
          class="detail-list"
          *ngFor="let food of suggestion.foods; let i = index"
        >
          <div class="detail-title" *ngIf="!food.foodId?.recipe">
            {{ food.foodId.name }}
          </div>
          <div
            class="detail-title link-to-recipe"
            *ngIf="food.foodId?.recipe"
            (click)="goToRecipe(food.foodId.recipe)"
          >
            <img src="assets/tabBar/tab3Selected.png" alt="" />

            <span> {{ food.foodId.name }}</span>
          </div>
          <div class="description">
            {{ suggestion.amount[i].amount }}
            {{ calorieCalculator.findSuggestionRatio(food).unitId.name }}
          </div>
        </div>
        <div
          class="change-package-button"
          (click)="
            changePackage(suggestion.foods, suggestion.amount, suggestion.id)
          "
        >
          تعویض پکیج
        </div> -->

        <p>{{ MergePackageFood(suggestion) }}</p>
        <img src="assets/general/left-gray.svg" alt="" />
      </div>
      <p
        *ngIf="isEmpty"
        style="text-align: center; color: rgb(102, 102, 102); width: 100%"
      >
        پکیج مورد نظر پیدا نشد .
      </p>
    </div>
    <div
      class="recent switcher-body"
      [ngStyle]="{ right: activeSwitch == 1 ? 0 : '100%' }"
    >
      <div *ngIf="recentPackage">
        <div
          class="food-option recent"
          [ngStyle]="{ 'margin-bottom': last ? '16px' : null }"
          *ngFor="let recent of recentPackage; let last = last"
        >
          <span class="remove-recent" (click)="removeItem(recent._id, meal)">
            <img src="assets/general/cross-white.svg" alt="" />
          </span>
          <!-- <span class="label"
            >{{
              calorieCalculator.calculateSuggestions(
                recent.foods,
                recent.amounts
              )
            }}
            کالری</span
          >
          <p class="title">پکیج پیشنهادی {{ title }}</p>
          <div
            class="detail-list"
            *ngFor="let food of recent.foods; let i = index"
          >
            <div class="detail-title" *ngIf="!food.foodId?.recipe">
              {{ food.foodId.name }}
            </div>
            <div
              class="detail-title link-to-recipe"
              *ngIf="food.foodId?.recipe"
              (click)="goToRecipe(food.foodId.recipe)"
            >
              <img src="assets/tabBar/tab3Selected.png" alt="" />

              <span> {{ food.foodId.name }}</span>
            </div>

            <div class="description">
              {{ recent.amounts[i].amount }}
              {{ calorieCalculator.findSuggestionRatio(food).unitId.name }}
            </div>
          </div>
          <div
            class="change-package-button"
            (click)="changePackage(recent.foods, recent.amounts, recent._id)"
          >
            تعویض پکیج
          </div> -->

          <p>{{ MergePackageFood(recent) }}</p>
          <img src="assets/general/left-gray.svg" alt="" />
        </div>
      </div>
      <div *ngIf="!recentPackage">
        <p style="text-align: center; color: #666">لیست خالی است</p>
      </div>
    </div>
  </div>
  <app-bottomsheet
    *ngIf="showFoodFactDetail"
    [type]="'foodFact'"
  ></app-bottomsheet>
</div>
